import apiRequestWrapper from "./react/actions/api_request";
import {confirmDialog} from "./react/actions/confirm";
import {infoNotify} from "./react/actions/notify";

$(function () {
    $('.logout-btn').click(function (event) {
        event.preventDefault();

        confirmDialog({
            title: 'Вы уверены?',
            text: 'Хотите выйти из кабинета?',
            confirmButtonText: 'Выйти',
            cancelButtonText: 'Отмена',
            confirmButtonVariant: 'logout',
        }).then((result) => {
            if (result.isConfirmed) {
                apiRequestWrapper(
                    LOGOUT_URL,
                    {},
                    (response, error) => {
                        if (!response.success || error) {
                            infoNotify('Your data was not sent');
                        }

                        window.location.href = LOGIN_URL;
                    }
                )
            }
        })
    });
});
